import { Directive, ElementRef, inject, input, InputSignal, OnInit } from '@angular/core';
import type { OrderHistoryItemModel } from '@libs/services/models';
import {
  LastOrderedProductModel} from '@libs/shop/models';
import {
  toTrackingAvailability,
  TRACKING_AVAILABILITY,
  TrackingPartialProductModel} from '@libs/shop/models';
import { ProductTrackingListDirective } from '../context';
import { ProductImpressionObserverService } from './product-impression-observer.service';

@Directive({
  selector: '[uiPartialProductImpression]',
})
export class PartialProductImpressionDirective implements OnInit {
  public partialProduct: InputSignal<LastOrderedProductModel | OrderHistoryItemModel> = input.required();
  public position: InputSignal<number> = input.required();

  private readonly elementRef: ElementRef<HTMLElement> = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly impressionObserver: ProductImpressionObserverService = inject(ProductImpressionObserverService);
  private readonly productTrackingList: ProductTrackingListDirective | null = inject(ProductTrackingListDirective, { optional: true });

  public ngOnInit(): void {
    const product: LastOrderedProductModel | OrderHistoryItemModel = this.partialProduct();

    const impression: TrackingPartialProductModel = {
      type: 'partialProduct',
      sku: this.isLastOrderedProduct(product) ? product.identifiers.sku : product.sku,
      salesUnitPrice: this.isLastOrderedProduct(product) ? product.prices?.salesUnit : product.prices.priceUnit,
      name: product.name,
      position: this.position(),
      quantity: 1,
      availability: this.isLastOrderedProduct(product) ? toTrackingAvailability(product.itemAvailable) : TRACKING_AVAILABILITY.notAvailable,
      trackingList: this.productTrackingList?.trackingList(),
    };

    this.impressionObserver.observeElement(this.elementRef.nativeElement, impression);
  }

  private isLastOrderedProduct(product: LastOrderedProductModel | OrderHistoryItemModel): product is LastOrderedProductModel {
    return (product as LastOrderedProductModel).type === 'last-ordered-products';
  }
}
